export const rule = {
  applyRule: {
    title: 'Registration ',
    titleBg: require('@/assets/img/title-bg.png'),
    descTitle: 'The competition is open to all university students from China and overseas (including undergraduate, postgraduate and doctoral students). Specific requirements are as follows:',
    list: [
      'Participants must be enrolled in the University without limitation of different degrees, disciplines or grades. ',
      'Participants must ensure that the registration information shall be truthful, accurate and effective. Each student may participate in only one team. Repeated registration will be invalid. '
    ]
  },
  process: {
    title: 'Competition Process',
    titleBg: require('@/assets/img/title-bg.png'),
    main: [
      {
        type: 'ai',
        icon: require('@/assets/transSave/resource/image/44/f7/44cfe8f0a4623f4e558331605cd441f7.png'),
        title: 'Artificial Intelligence',
        module: [
          {
            title: 'At Primary Phase',
            list: [
              'Registration: All participants are required to registration with submission of personal information. If needed, teaming is provided for any individual participants.Please make the registration for the competition firstly, and then register on Caiwei Platform, ensuring the information provided is consistent. Otherwise, it will be deemed as invalid. \nNotes: Team and individual participants are allowed for AI (hereinafter referred to as “Teams”) and each team may consist of 2-5 students. Team members with different grades, interdisciplinary or from different universities are allowed.',
              'After successful registration, teams shall download test testing data set via Caiwei platform, and the results generated from this testing data set will be submitted to the system for obtaining your results. ',
              'In case of multiple times of submission of the results, the latest version shall prevail. ',
              'Only 20 times of effective results can be submitted for each team during this phase.',
              'The system will develop twice review and ranking every day at primary phase at 12:00 and 24:00. The ranking will be made updated based on the review indicators. ',
              'After successful registration, teams can download Val testing data set via Caiwei platform, submit results and get the comparison results of model. The results can be used for debugging and model optimization rather than ranking. Total number of submissions of each team shall not be more than 5 times. '
            ]
          },
          {
            title: 'The Finals',
            list: [
              'Top 10 shortlisted teams on the rankings are for the finals at the deadline of primary phase. ',
              'Submission of Works: Shortlisted teams are required to submit related materials before the specified time including code, model, presentation, etc. ',
              'The Finals Presentation: Shortlisted teams must participate in the online roadshow presentation on 24 October on time for the final competition'
            ]
          }
        ]
      },
      {
        type: 'block',
        icon: require('@/assets/transSave/resource/image/04/40/047be085787327ff01d42f42f47a6540.png'),
        title: 'Blockchain',
        module: [
          {
            title: 'At Primary Phase',
            list: [
              'Registration: All participants are required to registration with submission of personal information. If needed, teaming is provided for any individual participants. \n Notes: The final competiton shall be team participants and each team may consist of 2-5 students. Team members with different grades, interdisciplinary or from different universities are allowed.',
              'Submission of works: The planning of works (including but not limited to product description, function features, technical development plan, commercial application scenario and value, teamwork arrangement, etc.) shall be submitted within the stipulated time. The works at primary phase shall include works introduction (PPT), works technical documents (DOC.) and videos.',
              'Submission Method: The works must be sent to the designated email address (fintechathon@g-ican.com) within the stipulated time. The title of email and works shall be [Name of Team + Name of Works].',
              'The open source (AI tracks shall be based on FISCO BCOS AND RELATED OPEN SOURCE SOLUTIONS for AI, including WeBASE middleware, WeCross General Cross-chain, WeIdentity digital identity management, WeEvent messaging collaboration, etc.) stipulated by the competition must be used for the works.  ',
              'The works can be perfected under the condition of without changing the topic of works and within the stipulated time. The final works is subject to the last version of submission within the specified time. Total number of submissions shall not be more than 3 times.'
            ]
          },
          {
            title: 'The Finals',
            list: [
              '10 shortlisted teams will be selected by the judges for the finals.',
              'Submission of Works: Shortlisted teams are required to submit related materials before the specified time including code, model, presentation, etc.',
              'The Finals Presentation: Shortlisted teams must participate in the online roadshow presentation on 24 October on time for the final competition ',
              'The overall direction of final works must be consistence with the works in the primary stage. Direction adjustment of works is not allowed.'
            ]
          }
        ]
      }
    ]
  },
  reviewRule: {
    title: 'Rules',
    titleBg: require('@/assets/img/title-bg.png'),
    main: [
      {
        type: 'ai',
        title: 'Artificial Intelligence',
        list: [
          {
            percent: '70%',
            title: 'Competition score at primary phase',
            desc: 'Scored based on the attack examples submitted by teams. '
          },
          {
            percent: '30%',
            title: 'Innovation and completion of scheme',
            desc: 'Comprehensively examined based on the innovation and completion of the scheme at the finals.'
          }
        ]
      },
      {
        type: 'block',
        title: 'Blockchain',
        list: [
          {
            percent: '40%',
            title: 'Product Completion',
            desc: 'The actual completion rate of works, technical skills and task effect.'
          },
          {
            percent: '30%',
            title: 'Commercial Value',
            desc: 'Consideration of the works in terms of market value, popularization, practicality, extensibility, clear performance of efficiency improvement and users’ requirements and expectation.'
          },
          {
            percent: '30%',
            title: 'Innovation',
            desc: 'Comprehensively examined regarding the innovation, originality, highlights, interaction design and user-friendliness of the works.'
          }
        ]
      }
    ]
  },
  notice: {
    title: 'Notice ',
    titleBg: require('@/assets/img/title-bg.png'),
    list: [
      'Each team shall independently complete the topic in accordance with relevant laws and regulations without any cheating, fraud, infringement of the intellectual property rights and other behaviors. Once the above-mentioned behaviors are founded or reported, the organizer shall have the right to cancel the qualification and competition results after verification.',
      'Participants reserve the intellectual property rights of the works. The organizer shall be entitled to make use of the information about works and teams for promotion, related publications, designated media release, browse and downloading on the official website and exhibition (including roadshow).',
      'There is no registration fee for this competition.'
    ]
  }
}
